import { render, staticRenderFns } from "./contactPage.vue?vue&type=template&id=48121bc5&scoped=true"
import script from "./contactPage.vue?vue&type=script&lang=js"
export * from "./contactPage.vue?vue&type=script&lang=js"
import style0 from "./contactPage.vue?vue&type=style&index=0&id=48121bc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48121bc5",
  null
  
)

export default component.exports